module.exports = __webpack_public_path__ + "img/slideset-relateditems_inactive.ab55a868.svg";